import React from 'react';
import i18n from '../../locales/index';
import { Row, Col, Container } from 'react-bootstrap'
import './index.css'
import TitleBold from '../../components/Text/TitleBold';
import TitleLight from '../../components/Text/TitleLight';
import MainStyles from '../../styles/MainStyles';
import BlueButtonOutlineDark from '../Buttons/BlueButtonOutlineDark';
import { convertDate, showCountDownDate, formatNumber } from '../../services/utils'

const ServiceStatus = ({ nextRevisionDate, nextRevisionOdometer, nextRevisionNumber }) => {
  return (
    <Container fluid="md">
      <Row className={'mainRow service-status-row'}>
        <Col md={{ span: 8 }} lg={9} xl={9} sm={7} xs={12}>
          <TitleBold
            text={i18n.t('service_status.title')}
            color={MainStyles.colors.black}
            ownClass={'service_text service_title'}
            size={'big'} />
          <TitleLight
            text={i18n.t('service_status.scheduled_until')}
            color={MainStyles.colors.black}
            size={'big'} />
          <TitleLight
            text={convertDate(nextRevisionDate.replace('00', '10'), true)}
            color={MainStyles.colors.black}
            size={'big'} />
        </Col>

        <Col md={{ span: 4 }} lg={3} xl={3} sm={4} xs={12} className='colRight '>
          <TitleBold
            text={`${nextRevisionNumber}${decodeURI('%C2%AA')} ${i18n.t('service_history.revision')}`}
            color={MainStyles.colors.black}
            ownClass={'service_text service_title'}
            size={'medium'} />
          <TitleLight
            text={formatNumber(nextRevisionOdometer)}
            color={MainStyles.colors.black}
            size={'bigger'} />

          <TitleLight
            text={` ${i18n.t('general.km')}`}
            color={MainStyles.colors.black}
            size={'big'} />

          <TitleLight
            text={` ${i18n.t('service_status.week_or')} 12 meses`}
            color={MainStyles.colors.black}
            ownClass={'service_text'}
            size={'small'} />

          <BlueButtonOutlineDark
            text={i18n.t('service_status.btn_schedule')}
            isRounded
            marginVertical
            onClick={() => {
              window.open('https://vwapps.volkswagen.com.br/Servicebook', '_blank')
            }}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default ServiceStatus
